import { RepeatIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';

export const data = {
  labels: ['Pending', 'Completed'],
  datasets: [
    {
      label: '# of User',
      data: [12, 19],
      backgroundColor: ['rgba(54, 162, 235, 0.2)', 'rgba(75, 192, 192, 0.2)'],
      borderColor: ['rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
      borderWidth: 1,
    },
  ],
};

ChartJS.register(ArcElement, Tooltip, Legend);

function SubQuestChart({
  pendingCount,
  completedCount,
  handleReloadData,
  ...rest
}) {
  return (
    <Flex
      direction="column"
      borderWidth="1px"
      align="center"
      borderRadius="md"
      p={4}
      {...rest}
    >
      <Flex mb={2} justify="center">
        <Text as="samp" fontSize="xs">
          <strong>PROGRESSION CHART</strong>
        </Text>

        <IconButton
          onClick={handleReloadData}
          aria-label="Reload table"
          variant="link"
          icon={<RepeatIcon />}
        />
      </Flex>

      <Box>
        <Doughnut
          data={{
            labels: ['Pending', 'Completed'],
            datasets: [
              {
                label: '# of User',
                data: [pendingCount, completedCount],
                backgroundColor: [
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                ],
                borderColor: ['rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
                borderWidth: 1,
              },
            ],
          }}
        />
      </Box>
    </Flex>
  );
}

SubQuestChart.defaultProps = {
  pendingCount: 0,
  completedCount: 0,
};

SubQuestChart.propTypes = {
  pendingCount: PropTypes.number,
  completedCount: PropTypes.number,
  handleReloadData: PropTypes.func.isRequired,
};

export default SubQuestChart;
